<template>
  <form action="#" name=FORM1>
    <v-layout row wrap>
      <v-flex xs12 sm10 md11 class="text-md-left">
        <strong>Firma</strong>
        <v-divider/>
      </v-flex>
      <v-flex xs12 sm2 md1 class="text-md-right text-sm-right">
        <v-btn color="primary" class="mb-2" dark @click="StartSign">Firmar</v-btn>
      </v-flex>
      <v-flex xs12 sm10 md11>
        <canvas id="cnv" name="cnv" width="500" height="100" ref="signature"/>
      </v-flex>
      <v-flex xs12 sm3 md2>
        <input type="hidden" name="bioSigData"/>
        <textarea name="sigRawData" rows="10" cols="32"
                  style="resize: none; display: none;">
                          Signature Raw Data:
                        </textarea>
      </v-flex>
      <v-flex xs12 sm3 md2>
        <input type="hidden" name="sigImgData"/>
        <textarea name="sigImageData" rows="10" cols="32"
                  style="resize: none; display: none;">
                          Signature Image Data:
                        </textarea>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
export default {
  name: 'signature',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      signatures: this.value,
    };
  },
  methods: {
    StartSign() {
      this.signatures = [];
      this.$emit('input', this.signatures);
      const canvasObj = document.getElementById('cnv');
      canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height);
      document.FORM1.sigRawData.value = 'Signature Raw Data: ';
      document.FORM1.sigImageData.value = 'Signature Image Data: ';
      this.imgWidth = canvasObj.width;
      this.imgHeight = canvasObj.height;
      const message = {
        firstName: '',
        lastName: '',
        eMail: '',
        location: '',
        imageFormat: 1,
        imageX: this.imgWidth,
        imageY: this.imgHeight,
        imageTransparency: false,
        imageScaling: false,
        maxUpScalePercent: 0.0,
        rawDataFormat: 'ENC',
        minSigPoints: 25,
        penThickness: 3,
        penColor: '#000000',
      };
      document.addEventListener('SigCaptureWeb_SignResponse', this.SignResponse, false);
      const messageData = JSON.stringify(message);
      const element = document.createElement('SigCaptureWeb_ExtnDataElem');
      element.setAttribute('SigCaptureWeb_MsgAttribute', messageData);
      document.documentElement.appendChild(element);
      const evt = document.createEvent('Events');
      evt.initEvent('SigCaptureWeb_SignStartEvent', true, false);
      element.dispatchEvent(evt);
    },
    SignResponse(event) {
      const str = event.target.getAttribute('SigCaptureWeb_msgAttri');
      const obj = JSON.parse(str);
      this.SetValues(obj, this.imgWidth, this.imgHeight);
    },
    SetValues(objResponse, imageWidth, imageHeight) {
      const obj = JSON.parse(JSON.stringify(objResponse));
      const ctx = document.getElementById('cnv').getContext('2d');

      if (obj.errorMsg != null && obj.errorMsg != '' && obj.errorMsg != 'undefined') {
        alert(obj.errorMsg);
      } else if (obj.isSigned) {
        document.FORM1.sigRawData.value += obj.rawData;
        document.FORM1.sigImageData.value += obj.imageData;
        const img = new Image();
        img.onload = function () {
          ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
        };
        img.src = `data:image/png;base64,${obj.imageData}`;
        this.signatures.push(`${obj.imageData}`);
        this.$emit('input', this.signatures);
      }
    },
    ClearFormData() {
      document.FORM1.sigRawData.value = 'Signature Raw Data: ';
      document.FORM1.sigImageData.value = 'Signature Image Data: ';
    },
  },
  mounted() {
    this.ClearFormData();
  },
};
</script>

<style scoped>

</style>
